import React, { Component } from 'react';
import { SelectedForVerification } from './SelectedForVerification';

class ConfirmationReviewContainer extends Component {
  path = '/confirmationreview';
  render() {
    return <SelectedForVerification isConfirmation={true} />;
  }
}

export const ConfirmationReview = ConfirmationReviewContainer;



// WEBPACK FOOTER //
// ./src/pages/selectedforverification/ConfirmationReview.js